module.exports = __webpack_public_path__ + "img/loading.b6beff50.svg";